export default "__VITE_ASSET__76394468__"